module.exports = "<my-train-form my-train=\"myTrain\"\n  enable-arrival=\"true\">\n</my-train-form>\n\n<div class=\"line-separator\"></div>\n\n<div class=\"section row\">\n  <my-radio-button ng-repeat=\"radio in currentTrainRadios\"\n    class=\"col s6\"\n    my-label=\"radio.label\"\n    my-id=\"radio.id\"\n    ng-model=\"myWagon.trainIsCurrent\"\n    my-value=\"radio.value\"\n    my-tabindex=\"-1\">\n  </my-radio-button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/entities/trains/wagon/directives/search/myWagonTrainSearch.html
// module id = 1131
// module chunks = 0